import styles from "./IconTarget.module.css";

export default function IconTarget({ size }: { size?: number }) {
  return (
    <svg
      id="Calque_4"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      width={size}
      height={size}
    >
      <path
        className={styles.cls2}
        d="M167.15,153.83c0,9.6-7.78,17.38-17.37,17.38s-17.38-7.78-17.38-17.38,7.77-17.37,17.38-17.37c3.34,0,6.46.94,9.11,2.58l-9.12,9.12,3.43,3.43,9.44-9.44s.08.09.12.14c2.73,3.06,4.39,7.1,4.39,11.54Z"
      />
      <path
        className={styles.cls2}
        d="M218.05,103.67c-1.54-2.1-3.18-4.12-4.91-6.07l-8.57,2.62-17.92,17.92c.04.05.08.09.13.14,8.86,9.23,14.3,21.75,14.3,35.55,0,28.34-22.96,51.32-51.3,51.32s-51.32-22.98-51.32-51.32,22.97-51.31,51.32-51.31c12.72,0,24.36,4.64,33.33,12.3l17.6-17.6,2.73-8.94c-.91-.75-1.84-1.48-2.79-2.19-14.17-10.66-31.78-16.98-50.87-16.98-7.71,0-15.18,1.03-22.27,2.96h-.01c-35.99,9.79-62.45,42.68-62.45,81.76,0,46.8,37.93,84.73,84.73,84.73,5.22,0,10.33-.47,15.29-1.39h.02c39.48-7.19,69.41-41.77,69.41-83.34,0-18.77-6.11-36.12-16.45-50.16Z"
      />
      <path
        className={styles.cls1}
        d="M127.51,72.07c-39.48,7.2-69.41,41.79-69.41,83.34,0,46.79,37.93,84.72,84.72,84.72,7.71,0,15.18-1.03,22.27-2.96"
      />
      <path
        className={styles.cls1}
        d="M167.15,153.83c0,9.6-7.78,17.38-17.37,17.38s-17.38-7.78-17.38-17.38,7.77-17.37,17.38-17.37c3.34,0,6.46.94,9.11,2.58l-9.12,9.12,3.43,3.43,9.44-9.44s.08.09.12.14c2.73,3.06,4.39,7.1,4.39,11.54Z"
      />
      <path
        className={styles.cls1}
        d="M167.15,153.83c0,9.6-7.78,17.38-17.37,17.38s-17.38-7.78-17.38-17.38,7.77-17.37,17.38-17.37c3.34,0,6.46.94,9.11,2.58l-9.12,9.12,3.43,3.43,9.44-9.44s.08.09.12.14c2.73,3.06,4.39,7.1,4.39,11.54Z"
      />
      <g>
        <polyline
          className={styles.cls1}
          points="158.89 139.04 183.11 114.82 200.71 97.22 206.78 91.15 215.65 82.28 222.92 75.01 223.35 74.58 226.78 78.01 219.5 85.29 211.7 93.09 210.27 94.52 204.57 100.22 186.65 118.14 162.64 142.15"
        />
        <polyline
          className={styles.cls1}
          points="226.78 78.01 241.91 79.36 233.57 86.99 226.42 93.54 213.14 97.6 204.57 100.22"
        />
        <line className={styles.cls1} x1="233.57" y1="86.99" x2="211.7" y2="93.08" />
        <line className={styles.cls1} x1="240.27" y1="79.71" x2="219.5" y2="85.28" />
        <polyline
          className={styles.cls1}
          points="222.92 75.01 221.57 59.87 213.94 68.22 207.39 75.37 203.44 88.28 200.71 97.22"
        />
        <line className={styles.cls1} x1="213.94" y1="68.21" x2="207.84" y2="90.08" />
        <line className={styles.cls1} x1="221.21" y1="61.51" x2="215.64" y2="82.28" />
      </g>
    </svg>
  );
}
